
import { defineComponent, PropType } from "vue";

export type SpinnerSize = "xs" | "sm" | "md" | "bg";
export type SpinnerColor = "white" | "red";

export default defineComponent({
    name: "SpinnerComponent",
    props: {
        size: {
            type: String as PropType<SpinnerSize>,
            default: "md",
        },
        color: {
            type: String as PropType<SpinnerColor>,
            default: "red",
        },
    },
});
